import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Panel, Empty, axis, grid, tip, C } from "./chartTheme";
import { groupStats } from "../../lib/reports";

export const TeamChart = ({ tests }) => {
  const data = groupStats(tests, (t) => t.team).sort((a, b) => b.dl - a.dl);
  return (
    <Panel title="Province comparison" testId="report-teams">
      {!data.length ? <Empty /> : (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data}>
            <CartesianGrid {...grid} />
            <XAxis dataKey="key" {...axis} />
            <YAxis {...axis} />
            <Tooltip {...tip} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
            <Legend wrapperStyle={{ fontSize: 10 }} />
            <Bar dataKey="dl" name="Avg ↓ Mbps" fill={C.blue} isAnimationActive={false} />
            <Bar dataKey="ul" name="Avg ↑ Mbps" fill={C.green} isAnimationActive={false} />
            <Bar dataKey="issueRate" name="Issue %" fill={C.red} isAnimationActive={false} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Panel>
  );
};
